import { SoapUtils } from "../../../utils/SoapUtils";

export interface EventItem {
    chargeable?:              string;
    createdBy?:               string;
    modified?:                string;
    remoteHeadId?:            string;
    remoteId?:                string;
    resourceId?:              string;
    status?:                  string;
    userId?:                  string;
    completed?:               string;
    multiEventTask?:          string;
    multiChange?:             string;
    commonId?:                string;
    forUser?:                 string;
    location?:                string;
    iversion?:                string;
    solutionStatus?:          string;
    developmentStatus?:       string;
    severity?:                string;
    isPrivate?:               string;
    activityId?:              string;
    projectId?:               string;
    folderId?:                string;
    nodeId?:                  string;
    customId?:                string;
    comments?:                string;
    reminder?:                string;
    addDuration?:             string;
    estimationHours?:         string;
    remainingHours?:          string;
    actualHours?:             string;
    plannedTaskCurrent?:      string;
    preChecklistForm?:        string;
    postChecklistForm?:       string;
    preChecklistFormValues?:  string;
    postChecklistFormValues?: string;
    milestones?:              string;
    description?:             string;
    htmlText?:                string;
    dateTo?:                  string;
    dateFrom?:                string;
    priority?:                string;
    entryType?:               string;
    distributionHandle?:      string;
    aclh?:                    string;
    headId?:                  string;
    headUserId?:              string;
    title?:                   string;
    contactsChanged?:         string;
    ident?:                   string;
    timeTracker?:             string;
    dimension1?:              string;
    dimension2?:              string;
    dimension3?:              string;
    taskTemplateId?:          string;
    USER?:                    User[];
    GARANT?:                  Garant[];
    CONTACT?:                 Contact[];
    DOCUMENT?:                Document[];
    DEPEND?:                  Depend[];
    RESOURCE?:                Resource;
    REPEAT?:                  Repeat;
    notify?:                  string;
    refId?:                   string;
}

export function toEventItemXml(event: EventItem): string {
    if(!event) return '';
    var xml = '';
    xml += SoapUtils.makeNode(event.chargeable, 'chargeable');
    xml += SoapUtils.makeNode(event.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(event.modified, 'modified');
    xml += SoapUtils.makeNode(event.remoteHeadId, 'remoteHeadId');
    xml += SoapUtils.makeNode(event.remoteId, 'remoteId');
    xml += SoapUtils.makeNode(event.resourceId, 'resourceId');
    xml += SoapUtils.makeNode(event.status, 'status');
    xml += SoapUtils.makeNode(event.userId, 'userId');
    xml += SoapUtils.makeNode(event.completed, 'completed');
    xml += SoapUtils.makeNode(event.multiEventTask, 'multiEventTask');
    xml += SoapUtils.makeNode(event.multiChange, 'multiChange');
    xml += SoapUtils.makeNode(event.commonId, 'commonId');
    xml += SoapUtils.makeNode(event.forUser, 'forUser');
    xml += SoapUtils.makeNode(event.location, 'location');
    xml += SoapUtils.makeNode(event.iversion, 'iversion');
    xml += SoapUtils.makeNode(event.solutionStatus, 'solutionStatus');
    xml += SoapUtils.makeNode(event.developmentStatus, 'developmentStatus');
    xml += SoapUtils.makeNode(event.severity, 'severity');
    xml += SoapUtils.makeNode(event.isPrivate, 'isPrivate');
    xml += SoapUtils.makeNode(event.activityId, 'activityId');
    xml += SoapUtils.makeNode(event.projectId, 'projectId');
    xml += SoapUtils.makeNode(event.folderId, 'folderId');
    xml += SoapUtils.makeNode(event.nodeId, 'nodeId');
    xml += SoapUtils.makeNode(event.customId, 'customId');
    xml += SoapUtils.makeNode(event.comments, 'comments');
    xml += SoapUtils.makeNode(event.reminder, 'reminder');
    xml += SoapUtils.makeNode(event.addDuration, 'addDuration');
    xml += SoapUtils.makeNode(event.estimationHours, 'estimationHours');
    xml += SoapUtils.makeNode(event.remainingHours, 'remainingHours');
    xml += SoapUtils.makeNode(event.actualHours, 'actualHours');
    xml += SoapUtils.makeNode(event.plannedTaskCurrent, 'plannedTaskCurrent');
    xml += SoapUtils.makeNode(event.preChecklistForm, 'preChecklistForm');
    xml += SoapUtils.makeNode(event.postChecklistForm, 'postChecklistForm');
    xml += SoapUtils.makeNode(event.preChecklistFormValues, 'preChecklistFormValues');
    xml += SoapUtils.makeNode(event.postChecklistFormValues, 'postChecklistFormValues');
    xml += SoapUtils.makeNode(event.milestones, 'milestones');
    xml += SoapUtils.makeNode(event.description, 'description');
    xml += SoapUtils.makeNode(event.htmlText, 'htmlText');
    xml += SoapUtils.makeNode(event.dateTo, 'dateTo');
    xml += SoapUtils.makeNode(event.dateFrom, 'dateFrom');
    xml += SoapUtils.makeNode(event.priority, 'priority');
    xml += SoapUtils.makeNode(event.entryType, 'entryType');
    xml += SoapUtils.makeNode(event.distributionHandle, 'distributionHandle');
    xml += SoapUtils.makeNode(event.aclh, 'aclh');
    xml += SoapUtils.makeNode(event.headId, 'headId');
    xml += SoapUtils.makeNode(event.headUserId, 'headUserId');
    xml += SoapUtils.makeNode(event.title, 'title');
    xml += SoapUtils.makeNode(event.contactsChanged, 'contactsChanged');
    xml += SoapUtils.makeNode(event.ident, 'ident');
    xml += SoapUtils.makeNode(event.timeTracker, 'timeTracker');
    xml += SoapUtils.makeNode(event.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(event.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(event.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(event.taskTemplateId, 'taskTemplateId');
    xml += SoapUtils.makeNodeArray(event.USER, toUserXml);
    xml += SoapUtils.makeNodeArray(event.GARANT, toGarantXml);
    xml += SoapUtils.makeNodeArray(event.CONTACT, toContactXml);
    xml += SoapUtils.makeNodeArray(event.DOCUMENT, toDocumentXml);
    xml += SoapUtils.makeNodeArray(event.DEPEND, toDependXml);
    xml += toResourceXml(event.RESOURCE);
    xml += toRepeatXml(event.REPEAT);
    xml += SoapUtils.makeNode(event.notify, 'notify');
    xml += SoapUtils.makeNode(event.refId, 'refId');
    //xml += '</EVENT>';
    return xml;
}


export interface Contact {
    id?: string;
}

export interface User {
    id?: string;
}

export function toContactXml(contact: Contact): string {
    if(!contact) return '';
    var xml = '<CONTACT>';
    xml += SoapUtils.makeNode(contact.id, 'id');
    xml += '</CONTACT>';
    return xml;
}

export function toUserXml(user: User): string {
    if(!user) return '';
    var xml = '<USER>';
    xml += SoapUtils.makeNode(user.id, 'id');
    xml += '</USER>';
    return xml;
}

export interface Depend {
    ident?: string;
    title?: string;
    type?:  string;
}

export function toDependXml(depend: Depend): string {
    if(!depend) return '';
    var xml = '<DEPEND>';
    xml += SoapUtils.makeNode(depend.ident, 'ident');
    xml += SoapUtils.makeNode(depend.title, 'title');
    xml += SoapUtils.makeNode(depend.type, 'type');
    xml += '</DEPEND>';
    return xml;
}

export interface Document {
    documentId?: string;
    name?:       string;
}

export function toDocumentXml(document: Document): string {
    if(!document) return '';
    var xml = '<DOCUMENT>';
    xml += SoapUtils.makeNode(document.documentId, 'documentId');
    xml += SoapUtils.makeNode(document.name, 'name');
    xml += '</DOCUMENT>';
    return xml;
}

export interface Garant {
    userId?: string;
    isGarant?: string;
}

export function toGarantXml(garant: Garant): string {
    if(!garant) return '';
    var xml = '<GARANT>';
    xml += SoapUtils.makeNode(garant.userId, 'userId');
    xml += SoapUtils.makeNode(garant.isGarant, 'isGarant');
    xml += '</GARANT>';
    return xml;
}

export interface Repeat {
    repeatMode?:        string;
    validFrom?:         string;
    validTo?:           string;
    repeatEvery?:       string;
    repeatDay?:         string;
    repeatMonth?:       string;
    repeatWeekDay?:     string;
    repeatWeekCount?:   string;
    repeatWeekDayList?: string;
    timeFrom?:          string;
    timeTo?:            string;
    useOffset?:         string;
    offset?:            string;
    limit?:             string;
    user?:              string;
}

export function toRepeatXml(repeat: Repeat | undefined): string {
    if(!repeat) return '';
    var xml = '<REPEAT>';
    xml += SoapUtils.makeNode(repeat.repeatMode, 'repeatMode');
    xml += SoapUtils.makeNode(repeat.validFrom, 'validFrom');
    xml += SoapUtils.makeNode(repeat.validTo, 'validTo');
    xml += SoapUtils.makeNode(repeat.repeatEvery, 'repeatEvery');
    xml += SoapUtils.makeNode(repeat.repeatDay, 'repeatDay');
    xml += SoapUtils.makeNode(repeat.repeatMonth, 'repeatMonth');
    xml += SoapUtils.makeNode(repeat.repeatWeekDay, 'repeatWeekDay');
    xml += SoapUtils.makeNode(repeat.repeatWeekCount, 'repeatWeekCount');
    xml += SoapUtils.makeNode(repeat.repeatWeekDayList, 'repeatWeekDayList');
    xml += SoapUtils.makeNode(repeat.timeFrom, 'timeFrom');
    xml += SoapUtils.makeNode(repeat.timeTo, 'timeTo');
    xml += SoapUtils.makeNode(repeat.useOffset, 'useOffset');
    xml += SoapUtils.makeNode(repeat.offset, 'offset');
    xml += SoapUtils.makeNode(repeat.limit, 'limit');
    xml += SoapUtils.makeNode(repeat.user, 'user');
    xml += '</REPEAT>';
    return xml;
}

export interface Resource {
    id?:           string;
    name?:         string;
    description?:  string;
    categoryId?:   string;
    needApproval?: string;
}

export function toResourceXml(resource:Resource | undefined): string {
    if(!resource) return '';
    var xml = '<RESOURCE>';
    xml += SoapUtils.makeNode(resource.id, 'id');
    xml += SoapUtils.makeNode(resource.name, 'name');
    xml += SoapUtils.makeNode(resource.description, 'description');
    xml += SoapUtils.makeNode(resource.categoryId, 'categoryId');
    xml += SoapUtils.makeNode(resource.needApproval, 'needApproval');
    xml += '</RESOURCE>';
    return xml;
}